/**
 * モジュール読み込み
 */
import { Initialize } from './modules/Initialize';


/**
 * 実行クラス
 */
new (class Main {
  /**
   * コンストラクタ
   */
  constructor() {
    /**
     * HTML要素にクラス名を追加 (先頭に記述)
     */
    const initialize: Initialize = new Initialize();
    initialize.setHtmlClass();

    /**
     * object-fit polyfill
     */
    const objectFitImages: any = require('object-fit-images');
    objectFitImages();

    /**
     * スムーススクロール
     */
    // const SmoothScroll: any = require('smooth-scroll');
    // const smooth: any = new SmoothScroll('a[href*="#"]', {
    //   speed: 500,
    //   speedAsDuration: true,
    //   ignore: '.scroll-ignore',
    //   offset: (anchor: any, toggle: any): number => {
    //     return document.querySelector('.header')!.clientHeight;
    //   },
    // });

    /**
     * スクロールイベント（ヘッダー・ページトップボタン）
     */
    this.scrollElements('.fn-header', '.fn-pageTop');

    /**
     * inview
     */
    const inview: any = require('jquery-inview');
    this.setInview('.fn-inview');

    /**
     * フォームバリデーション
     */
    // const validator: any = require('parsleyjs');

    /**
     * メインビジュアル
     */
    this.setTyping('.fn-inviewTyping', '#first');

    /**
     * 講師
     */
    this.setAccordion('.box-teacher', '.box-teacher__head', '.box-teacher__body', '.box-teacher__close');
  }

  /**
   * スクロールイベント（ヘッダー・ページトップボタン）
   */
  scrollElements(header: string, btn: string): void {
    const $header: JQuery = $(header);
    const $btn: JQuery = $(btn);
    const windowHeight: number | undefined= $(window).height();

    if (! $btn && ! $header) {
      return;
    }

    $(window).on('load', (): void => {
      this.setShowClass($header, $btn, windowHeight);
    });

    $(window).scroll((): void => {
      this.setShowClass($header, $btn, windowHeight);
    });
  }

  setShowClass($header: JQuery, $btn: JQuery, windowHeight: number | undefined): void  {
    let scrollTop: number | undefined = $(window).scrollTop();

    if (scrollTop! > windowHeight! / 3 * 1) {
      $header.addClass('is-scroll');
      $btn.addClass('is-show').fadeIn(300);
    } else {
      $header.removeClass('is-scroll');
      $btn.removeClass('is-show').fadeOut(300);
    }
  };

  /**
   * inview
   * @param element ターゲット要素
   */
  setInview(element: string): void {
    const $inview: any = $(element);

    $inview.each((index: number, element: Element): void => {
      const $this: any = $(element);
      $this.on('inview', (event: Event, isInView: any): void => {
        if (isInView) {
          $this.addClass('is-active');
        }
      });
    });
  }

  /**
   * メインビジュアル
   */
  setTyping(target: string, first: string): void {
    const $target: JQuery = $(target);
    const $first: any = $(first);

    setTimeout((): void => {
      $target.addClass('is-end');
    }, 6800);

    if ($first) {
      setTimeout((): void => {
        let position:any = $("html,body").scrollTop();
        console.log(position);
        if (position < 200) {
          $("html,body").animate({scrollTop: $first.offset().top + 5}, 800,"swing");
        }
      }, 7300);
    }
  }

  /**
   * 講師
   */
  setAccordion(box: string, head: string, body: string, btn: string): void {
    const $box: JQuery = $(box);
    const headClass: string = head;
    const bodyClass: string = body;
    const btnClass: any = btn;
    const $headAll: any = $(head);
    const $bodyAll: any = $(body);

    $box.each((index: number, element: Element): void => {
      const $this: any = $(element);
      const $head: any = $(element).find(headClass);
      const $body: any = $(element).find(bodyClass);
      const $btn: any = $(element).find(btnClass);
      const closeHeight: any = $body.height();

      $head.on('click', (): void => {
        if($head.hasClass('is-open')) {
          $head.removeClass('is-open');
          $body.removeClass('is-open').css({'z-index': 0}).animate({height: 0}, 0);
        } else {
          const autoHeight: any = $body.css({'height':'auto', 'z-index': 1}).height();
          $head.addClass('is-open');
          $body.addClass('is-open').height(closeHeight).animate({height: autoHeight, 'z-index': 1}, 0);
          $headAll.not($head).removeClass('is-open');
          $bodyAll.not($body).removeClass('is-open').css({'z-index': 0}).animate({height: 0}, 10);
          setTimeout(() => {
            $("html,body").animate({scrollTop: $head.offset().top}, 500, "swing");
          }, 500);
        }
      });

      $btn.on('click', function(event: any): void {
        $headAll.removeClass('is-open');
        $bodyAll.removeClass('is-open').css({'z-index': 0}).animate({height: 0}, 0);
        $("html,body").animate({scrollTop: $head.offset().top - 50}, 300,"swing");
      });
    });
  }

})();
